import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

/**
 * Intercepta las peticiones XHR del SDK de Synapsis para redirigirlas
 * a través del proxy de desarrollo, evitando problemas de CORS.
 * Solo se activa en desarrollo (cuando baseUrl usa proxy '/api').
 */
// let interceptorInstalled = false;

// function installSdkProxyInterceptor(): void {
//   if (!environment.sdk.useProxyInterceptor || interceptorInstalled) return;

//   interceptorInstalled = true;

//   const targets = [
//     'http://localhost:3000',
//     environment.paylink.baseUrl // dinámico
//   ];

//   const originalOpen = XMLHttpRequest.prototype.open;

//   XMLHttpRequest.prototype.open = function (
//     this: XMLHttpRequest,
//     method: string,
//     url: string | URL,
//     async?: boolean,
//     username?: string | null,
//     password?: string | null
//   ) {
//     let finalUrl = typeof url === 'string' ? url : url.toString();

//     const matchedTarget = targets.find(target => finalUrl.startsWith(target));

//     if (matchedTarget) {
//       finalUrl = finalUrl.replace(matchedTarget, '');
//       console.log(`[sdk-proxy] ${method} ${matchedTarget} → ${finalUrl}`);
//     }

//     originalOpen.call(this, method, finalUrl, async ?? true, username ?? null, password ?? null);
//   };
// }

// installSdkProxyInterceptor();

declare global {
  interface Window {
    __PAYMENT_LINK_RUNTIME__?: {
      sdkLoaded: boolean;
      sdkError?: string;
    };
    Synap?: {
      Form: new (config: {
        environment: string;
        authentication: string | Record<string, string>;
        transaction: unknown;
        listeners?: {
          afterPay?: (response: any) => void;
        };
      }) => {
        render: (selector: string) => void;
      };
    };
  }
}

function setRuntimeSdkState(sdkLoaded: boolean, sdkError?: string): void {
  window.__PAYMENT_LINK_RUNTIME__ = { sdkLoaded, sdkError };
}

function loadSynapsisSdk(): Promise<boolean> {
  if (!environment.sdk.loadOnStartup) {
    setRuntimeSdkState(false, 'SDK deshabilitado por configuración');
    return Promise.resolve(false);
  }

  return new Promise<boolean>((resolve) => {
    const existing = document.querySelector(`script[src="${environment.sdk.url}"]`);

    if (existing) {
      setRuntimeSdkState(true);
      return resolve(true);
    }

    const script = document.createElement('script');
    script.src = environment.sdk.url;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setRuntimeSdkState(true);
      resolve(true);
    };

    script.onerror = () => {
      const error = `No se pudo cargar SDK desde ${environment.sdk.url}`;
      console.error('[payment-link]', error);
      setRuntimeSdkState(false, error);
      resolve(false);
    };

    document.body.appendChild(script);
  });
}

// async function startApp(): Promise<void> {
//   const sdkLoaded = await loadSynapsisSdk();

//   if (!sdkLoaded && !environment.sdk.allowBootstrapWithoutSdk) {
//     console.error('[payment-link] Bootstrap cancelado: SDK obligatorio no disponible.');
//     return;
//   }

//   bootstrapPaymentLink().catch((error) => {
//     console.error('[payment-link] Error durante bootstrap:', error);
//   });
// }

// function bootstrapPaymentLink(): Promise<unknown> {
//   return bootstrapApplication(AppComponent, appConfig);
// }

// startApp();

async function bootstrap(): Promise<void> {
  try {
    const sdkLoaded = await loadSynapsisSdk();

    if (!sdkLoaded && !environment.sdk.allowBootstrapWithoutSdk) {
      console.error('[payment-link] SDK obligatorio no disponible. Bootstrap cancelado.');
      return;
    }

    await bootstrapApplication(AppComponent, appConfig);

  } catch (error) {
    console.error('[payment-link] Error durante bootstrap:', error);
  }
}

bootstrap();
